import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from "redux-thunk";
import rootReducer from '../reducers';
import { persistStore, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';

const persistConfig = {
	key: 'adminPortal',
	storage,
	whitelist: ['account', 'auth'],
};

const reducer = persistCombineReducers(persistConfig, rootReducer);

const store = createStore(reducer, compose(applyMiddleware(thunk)));

const persistor = persistStore(store);

export { store, persistor };
